import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import 'react-international-phone/style.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import WebFont from 'webfontloader'
import './localization/i18n'
if (import.meta.env.PROD && process.env.CI !== 'true') {
  Sentry.init({
    dsn: import.meta.env.VITE_REACT_APP_SENTRY_DSN,
  })
}
WebFont.load({
  google: {
    families: ['Roboto:300,400,500,600,700', 'sans-serif'],
  },
})
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
